import Loadable from 'react-loadable';
import Loading from '@/components/Loading'
const Dashboard = Loadable({loader: () => import(/*webpackChunkName:'Dashboard'*/'@/views/dashboard'),loading: Loading});
const Upload = Loadable({loader: () => import(/*webpackChunkName:'Upload'*/'@/views/upload'),loading: Loading});
const WechatUser = Loadable({loader: () => import(/*webpackChunkName:'WechatUser'*/'@/views/wechat-user'),loading: Loading});
const Feedback = Loadable({loader: () => import(/*webpackChunkName:'Feedback'*/'@/views/feedback'),loading: Loading});
const Account = Loadable({loader: () => import(/*webpackChunkName:'Account'*/'@/views/account'),loading: Loading});
const Clipboard = Loadable({loader: () => import(/*webpackChunkName:'Clipboard'*/'@/views/clipboard'),loading: Loading});
const Error404 = Loadable({loader: () => import(/*webpackChunkName:'Error404'*/'@/views/error/404'),loading: Loading});

export default [
  { path: "/dashboard", component: Dashboard, roles: ["admin","editor","guest"] },
  { path: "/upload", component: Upload, roles: ["admin","editor"] },
  { path: "/wechat-user", component: WechatUser, roles: ["admin","editor"] },
  { path: "/feedback", component: Feedback, roles: ["admin","editor"] },
  { path: "/account", component: Account, roles: ["admin"] },
  { path: "/clipboard", component: Clipboard, roles: ["admin","editor"] },
  { path: "/error/404", component: Error404 },
];
